// src/components/QuotaScreen.jsx

import React from 'react';
import './LoginScreen.css'; // Reuse layout styles

export default function QuotaScreen({ company, role, experimentsToday, dailyLimit, setUiState, handleLogout }) {

  const djangoUrl = process.env.REACT_APP_DJANGO_URL;

  const handleSubscribe = () => {
    const proceed = window.confirm(
      "Upgrade flow coming soon!\n\nWould you like to visit our contact form?\nClick 'Cancel' to logout instead."
    );
    if (proceed) {
      handleLogout(); // close session first
      window.location.href = `${djangoUrl}/contact`;
    } else {
      handleLogout();
    }
  };

  const handleLearnMore = () => {
    const proceed = window.confirm(
      "Tier details coming soon!\n\nWould you like to visit our contact form?\nClick 'Cancel' to logout instead."
    );
    if (proceed) {
      handleLogout(); // close session first
      window.location.href = `${djangoUrl}/contact`;
    } else {
      handleLogout();
    }
  };

  return (
    <div className="login-wrapper">
      <div className="login-screen">
        <h2>Welcome {role} at {company}</h2>
        <p>You’ve reached your daily experiment limit.</p>
        <p>{experimentsToday} of {dailyLimit} experiments used today.</p>
        <p style={{ marginTop: '1rem', fontStyle: 'italic', color: '#555' }}>
          Your quota will renew tomorrow — we look forward to seeing what you discover next.
        </p>
          <div style={{ marginTop: '2rem' }}>

            <button 
              onClick={handleSubscribe} style={primaryButtonStyle}>
              Upgrade Plan
            </button>

            <button onClick={handleLearnMore} style={secondaryButtonStyle}>
              Learn About Tiers
            </button>

          </div>

        <button onClick={handleLogout} style={logoutButtonStyle}>
          Logout
        </button>

      </div>
    </div>
  );
}

const primaryButtonStyle = {
  padding: '0.75rem 1.5rem',
  fontWeight: 'bold',
  backgroundColor: '#0077cc',
  color: 'white',
  border: 'none',
  borderRadius: '6px',
  marginRight: '1rem',
  cursor: 'pointer'
};

const secondaryButtonStyle = {
  padding: '0.75rem 1.5rem',
  fontWeight: 'bold',
  backgroundColor: '#eee',
  color: '#333',
  border: 'none',
  borderRadius: '6px',
  cursor: 'pointer'
};

const logoutButtonStyle = {
  marginTop: '2.5rem',
  backgroundColor: '#eee',
  color: '#333',
  border: 'none',
  borderRadius: '6px',
  padding: '0.75rem 1.5rem',
  cursor: 'pointer'
};